import React from "react";

const StateDataCard = ({ statecases }) => {
  return (
    <div>
      <div className="row">
        <div className="col s12 m8 offset-l2">
          <div className="card">
            <table className="striped">
              <thead>
                <tr>
                  <th>State</th>
                  <th>Total</th>
                  <th>Active</th>
                  <th>Cured</th>
                  <th>Deaths</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{statecases[0]?.state}</td>
                  <td>{statecases[0]?.confirmed}</td>
                  <td>{statecases[0]?.active}</td>
                  <td>{statecases[0]?.recovered}</td>
                  <td>{statecases[0]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[1]?.state}</td>
                  <td>{statecases[1]?.confirmed}</td>
                  <td>{statecases[1]?.active}</td>
                  <td>{statecases[1]?.recovered}</td>
                  <td>{statecases[1]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[2]?.state}</td>
                  <td>{statecases[2]?.confirmed}</td>
                  <td>{statecases[2]?.active}</td>
                  <td>{statecases[2]?.recovered}</td>
                  <td>{statecases[2]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[3]?.state}</td>
                  <td>{statecases[3]?.confirmed}</td>
                  <td>{statecases[3]?.active}</td>
                  <td>{statecases[3]?.recovered}</td>
                  <td>{statecases[3]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[4]?.state}</td>
                  <td>{statecases[4]?.confirmed}</td>
                  <td>{statecases[4]?.active}</td>
                  <td>{statecases[4]?.recovered}</td>
                  <td>{statecases[4]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[5]?.state}</td>
                  <td>{statecases[5]?.confirmed}</td>
                  <td>{statecases[5]?.active}</td>
                  <td>{statecases[5]?.recovered}</td>
                  <td>{statecases[5]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[6]?.state}</td>
                  <td>{statecases[6]?.confirmed}</td>
                  <td>{statecases[6]?.active}</td>
                  <td>{statecases[6]?.recovered}</td>
                  <td>{statecases[6]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[7]?.state}</td>
                  <td>{statecases[7]?.confirmed}</td>
                  <td>{statecases[7]?.active}</td>
                  <td>{statecases[7]?.recovered}</td>
                  <td>{statecases[7]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[8]?.state}</td>
                  <td>{statecases[8]?.confirmed}</td>
                  <td>{statecases[8]?.active}</td>
                  <td>{statecases[8]?.recovered}</td>
                  <td>{statecases[8]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[9]?.state}</td>
                  <td>{statecases[9]?.confirmed}</td>
                  <td>{statecases[9]?.active}</td>
                  <td>{statecases[9]?.recovered}</td>
                  <td>{statecases[9]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[10]?.state}</td>
                  <td>{statecases[10]?.confirmed}</td>
                  <td>{statecases[10]?.active}</td>
                  <td>{statecases[10]?.recovered}</td>
                  <td>{statecases[10]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[11]?.state}</td>
                  <td>{statecases[11]?.confirmed}</td>
                  <td>{statecases[11]?.active}</td>
                  <td>{statecases[11]?.recovered}</td>
                  <td>{statecases[11]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[12]?.state}</td>
                  <td>{statecases[12]?.confirmed}</td>
                  <td>{statecases[12]?.active}</td>
                  <td>{statecases[12]?.recovered}</td>
                  <td>{statecases[12]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[13]?.state}</td>
                  <td>{statecases[13]?.confirmed}</td>
                  <td>{statecases[13]?.active}</td>
                  <td>{statecases[13]?.recovered}</td>
                  <td>{statecases[13]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[14]?.state}</td>
                  <td>{statecases[14]?.confirmed}</td>
                  <td>{statecases[14]?.active}</td>
                  <td>{statecases[14]?.recovered}</td>
                  <td>{statecases[14]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[15]?.state}</td>
                  <td>{statecases[15]?.confirmed}</td>
                  <td>{statecases[15]?.active}</td>
                  <td>{statecases[15]?.recovered}</td>
                  <td>{statecases[15]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[16]?.state}</td>
                  <td>{statecases[16]?.confirmed}</td>
                  <td>{statecases[16]?.active}</td>
                  <td>{statecases[16]?.recovered}</td>
                  <td>{statecases[16]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[17]?.state}</td>
                  <td>{statecases[17]?.confirmed}</td>
                  <td>{statecases[17]?.active}</td>
                  <td>{statecases[17]?.recovered}</td>
                  <td>{statecases[17]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[18]?.state}</td>
                  <td>{statecases[18]?.confirmed}</td>
                  <td>{statecases[18]?.active}</td>
                  <td>{statecases[18]?.recovered}</td>
                  <td>{statecases[18]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[19]?.state}</td>
                  <td>{statecases[19]?.confirmed}</td>
                  <td>{statecases[19]?.active}</td>
                  <td>{statecases[19]?.recovered}</td>
                  <td>{statecases[19]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[20]?.state}</td>
                  <td>{statecases[20]?.confirmed}</td>
                  <td>{statecases[20]?.active}</td>
                  <td>{statecases[20]?.recovered}</td>
                  <td>{statecases[20]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[21]?.state}</td>
                  <td>{statecases[21]?.confirmed}</td>
                  <td>{statecases[21]?.active}</td>
                  <td>{statecases[21]?.recovered}</td>
                  <td>{statecases[21]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[22]?.state}</td>
                  <td>{statecases[22]?.confirmed}</td>
                  <td>{statecases[22]?.active}</td>
                  <td>{statecases[22]?.recovered}</td>
                  <td>{statecases[22]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[23]?.state}</td>
                  <td>{statecases[23]?.confirmed}</td>
                  <td>{statecases[23]?.active}</td>
                  <td>{statecases[23]?.recovered}</td>
                  <td>{statecases[23]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[24]?.state}</td>
                  <td>{statecases[24]?.confirmed}</td>
                  <td>{statecases[24]?.active}</td>
                  <td>{statecases[24]?.recovered}</td>
                  <td>{statecases[24]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[25]?.state}</td>
                  <td>{statecases[25]?.confirmed}</td>
                  <td>{statecases[25]?.active}</td>
                  <td>{statecases[25]?.recovered}</td>
                  <td>{statecases[25]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[26]?.state}</td>
                  <td>{statecases[26]?.confirmed}</td>
                  <td>{statecases[26]?.active}</td>
                  <td>{statecases[26]?.recovered}</td>
                  <td>{statecases[26]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[27]?.state}</td>
                  <td>{statecases[27]?.confirmed}</td>
                  <td>{statecases[27]?.active}</td>
                  <td>{statecases[27]?.recovered}</td>
                  <td>{statecases[27]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[28]?.state}</td>
                  <td>{statecases[28]?.confirmed}</td>
                  <td>{statecases[28]?.active}</td>
                  <td>{statecases[28]?.recovered}</td>
                  <td>{statecases[28]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[29]?.state}</td>
                  <td>{statecases[29]?.confirmed}</td>
                  <td>{statecases[29]?.active}</td>
                  <td>{statecases[29]?.recovered}</td>
                  <td>{statecases[29]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[30]?.state}</td>
                  <td>{statecases[30]?.confirmed}</td>
                  <td>{statecases[30]?.active}</td>
                  <td>{statecases[30]?.recovered}</td>
                  <td>{statecases[30]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[31]?.state}</td>
                  <td>{statecases[31]?.confirmed}</td>
                  <td>{statecases[31]?.active}</td>
                  <td>{statecases[31]?.recovered}</td>
                  <td>{statecases[31]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[32]?.state}</td>
                  <td>{statecases[32]?.confirmed}</td>
                  <td>{statecases[32]?.active}</td>
                  <td>{statecases[32]?.recovered}</td>
                  <td>{statecases[32]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[33]?.state}</td>
                  <td>{statecases[33]?.confirmed}</td>
                  <td>{statecases[33]?.active}</td>
                  <td>{statecases[33]?.recovered}</td>
                  <td>{statecases[33]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[34]?.state}</td>
                  <td>{statecases[34]?.confirmed}</td>
                  <td>{statecases[34]?.active}</td>
                  <td>{statecases[34]?.recovered}</td>
                  <td>{statecases[34]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[35]?.state}</td>
                  <td>{statecases[35]?.confirmed}</td>
                  <td>{statecases[35]?.active}</td>
                  <td>{statecases[35]?.recovered}</td>
                  <td>{statecases[35]?.deaths}</td>
                </tr>
                <tr>
                  <td>{statecases[36]?.state}</td>
                  <td>{statecases[36]?.confirmed}</td>
                  <td>{statecases[36]?.active}</td>
                  <td>{statecases[36]?.recovered}</td>
                  <td>{statecases[36]?.deaths}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StateDataCard;
